import React from 'react'
import InformationItems from '../components/InformationItems'
import { getUserJobList } from '../api/getUserJobList'
import { deleteUserJob } from '../api/deleteUserJob'
import { FieldValues, UseFormReturn } from 'react-hook-form'
import TextField from '../components/TextField'
import { ERROR_DICT, errorDict } from '../utils/errorDict'
import CheckboxSingle from '../components/CheckboxSingle'
import { addUserJob } from '../api/addUserJob'
import { updateUserJob } from '../api/updateUserJob'

function ProfileEditJobPage(): React.ReactElement {
  const fields = ({
    control,
    formState: { errors },
    watch
  }: UseFormReturn<FieldValues, any>) => {
    const watchPresentValue = watch('present')

    return (
      <>
        <TextField
          name={'organization'}
          control={control}
          label={'Место работы'}
          required
          rules={{ required: true }}
          hasError={!!errors.organization}
          errorText={errorDict(errors.organization)}
        ></TextField>
        <TextField
          name={'department'}
          control={control}
          label={'Подразделение'}
        ></TextField>
        <TextField
          name={'position'}
          control={control}
          label={'Должность'}
          required
          rules={{ required: true }}
          hasError={!!errors.position}
          errorText={errorDict(errors.position)}
        ></TextField>
        <div className={'row row-gap-20 row-mobile-none'}>
          <TextField
            className={'u-flexGrow1'}
            control={control}
            rules={{ required: true }}
            hasError={!!errors.startYear}
            errorText={errorDict(errors.startYear)}
            name="startYear"
            datepickerOptions={{
              view: 'years',
              minView: 'years',
              dateFormat: 'yyyy'
            }}
            type="date"
            label="Год начала работы"
            required
          ></TextField>
          <TextField
            className={'u-flexGrow1'}
            control={control}
            rules={{
              validate: (value, formValues) => {
                return !!value || !!formValues.present
              }
            }}
            hasError={!!errors.endYear}
            errorText={ERROR_DICT.required}
            name="endYear"
            datepickerOptions={{
              view: 'years',
              minView: 'years',
              dateFormat: 'yyyy'
            }}
            type="date"
            label="Год окончания работы"
            required={!watchPresentValue}
          ></TextField>
        </div>
        <CheckboxSingle
          name={'present'}
          control={control}
          hideDetails
          className={'text-body-bold'}
        >
          По настоящее время
        </CheckboxSingle>
        <CheckboxSingle
          name={'main'}
          control={control}
          className={'text-body-bold mt-md-4 mt-sm-3'}
        >
          Данные для профиля
        </CheckboxSingle>
      </>
    )
  }

  return (
    <InformationItems
      addMethod={addUserJob}
      deleteMethod={deleteUserJob}
      updateMethod={updateUserJob}
      updateSuccessText={'Информация об опыте работы успешно изменена'}
      addSuccessText={'Информация об опыте работы успешно добавлена'}
      deleteSuccessText={'Информация об опыте работы успешно удалена'}
      emptyText={'Информация об опыте работы не найдена'}
      addButtonText={'Добавить место работы'}
      addTitleText={'Новое место работы'}
      listMethod={getUserJobList}
      renderView={(item: any) => {
        return (
          <div>
            <div className={'text-h4'}>{item.organization}</div>
            {item.department ? (
              <div className={'text-caption text-secondary-color mt-2'}>
                {item.department}
              </div>
            ) : null}
            <div className={'text-caption text-secondary-color mt-2'}>
              {item.position}
            </div>
          </div>
        )
      }}
      renderAdd={fields}
      renderUpdate={fields}
    ></InformationItems>
  )
}

export default ProfileEditJobPage
